import { useEffect, useMemo, useState } from "react";
import { FormControl } from "react-bootstrap";
import { useSharedSafariContext } from "../../provider/ShareSafariProvider";
import { useMasterContext } from "../../provider/MasterProvider";
import Select from "react-select";
import AccommodationFilterSkeleton from "components/common/Skeleton/park/filter/AccommodationFilterSkeleton";
import rupeeFormat from "components/Api/RupeeFormat";
import debounce from "lodash.debounce";
import { common } from "Data/common";

const ShareSafariFilter = () => {
  const { filters, sharedSafariDispatch } = useSharedSafariContext();
  const {
    parks,
    months,
    safariType,
    safariAgenda,
    safariCategory,
    safariHostType,
    masterLoading,
  } = useMasterContext();
  const [costMin, setCostMin] = useState(filters?.estimate_price_min || 100);
  const [costMax, setCostMax] = useState(
    filters?.estimate_price_max || 50000
  );
  const [safariMin, setSafariMin] = useState(filters?.no_of_safari_min || 1);
  const [safariMax, setSafariMax] = useState(filters?.no_of_safari_max || 10);

  const FILTER = common?.SHARED_SAFARI?.MAIN?.FILTER;

  const updateFilter = (name, value) => {
    sharedSafariDispatch({
      type: "UPDATE_SHARED_SAFARI_FILTER",
      payload: { [name]: value },
    });
  };

    /*-----------for Total Safaries----start--------*/
  // Debounced updateFilter
  const debounceSafariFilter = useMemo(() => {
    return debounce((name, value) => {
      updateFilter(name, value);
    }, 300); // 300ms debounce delay
  }, []);

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debounceSafariFilter.cancel();
    };
  }, [debounceSafariFilter]);

  useEffect(() => {
    setSafariMin(filters?.no_of_safari_min || 1);
    setSafariMax(filters?.no_of_safari_max || 10);
  }, [filters.no_of_safari_min, filters.no_of_safari_max]);
  /*-----------for otal Safaries-----END--------*/

    /*-----------for cost per person----start--------*/
  // Debounced updateFilter
  const debouncedUpdateFilter = useMemo(() => {
    return debounce((name, value) => {
      updateFilter(name, value);
    }, 300); // 300ms debounce delay
  }, []);

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedUpdateFilter.cancel();
    };
  }, [debouncedUpdateFilter]);

  useEffect(() => {
    setCostMin(filters?.estimate_price_min || 100);
    setCostMax(filters?.estimate_price_max || 50000);
  }, [filters.estimate_price_min, filters.estimate_price_max]);
  /*-----------for cost per person----END--------*/

  return (
    <div className="filter-wrapper d-lg-block d-none p-3">
      <div className="title_top pb-4">
        <h4>{FILTER?.TITLE}</h4>
      </div>

      <div className="title_filter mb-3">
        <h6>{FILTER?.SAFARI_PARK}</h6>
        <Select
          value={parks?.find((p) => p.value === filters?.park_id) || null}
          onChange={(selectedOption) =>
            updateFilter("park_id", selectedOption?.value || 0)
          }
          options={parks}
          isSearchable
          isClearable
          placeholder={FILTER?.ANY_ALL}
          components={{ IndicatorSeparator: () => null }}
        />
      </div>

      <div className="title_filter mb-3">
        <h6>{FILTER?.MONTH}</h6>
        <Select
          value={months?.find((p) => p.value === filters?.month_id) || null}
          onChange={(selectedOption) =>
            updateFilter("month_id", selectedOption?.value || 0)
          }
          options={months}
          isSearchable
          placeholder={FILTER?.ANY_ALL}
          isClearable
          components={{ IndicatorSeparator: () => null }}
        />
      </div>
      <div className="title_filter mb-3">
        <h6>{FILTER?.TYPE}</h6>
        <div className="input_check">
          {Array.isArray(safariType) && safariType.length > 0 ? (
            safariType.map((type) => (
              <div className="d-flex align-items-center pt-1" key={type.value}>
                <input
                  type="checkbox"
                  className="type checkbox_design me-3"
                  id={`type-${type.value}`}
                  value={type.value}
                  checked={
                    Array.isArray(filters?.type) &&
                    filters.type.includes(type.value)
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const current = filters?.type || [];
                    const newValues = checked
                      ? [...current, type.value]
                      : current.filter((v) => v !== type.value);
                    updateFilter("type", newValues);
                  }}
                />
                <label htmlFor={`type-${type.value}`}>{type.label}</label>
              </div>
            ))
          ) : masterLoading ? (
            <AccommodationFilterSkeleton count={2} />
          ) : (
            <p>{FILTER?.NO_FILTER}</p>
          )}
        </div>
      </div>
      <div className="title_filter mb-3">
        <h6>{FILTER?.BUDGET_PER_PERSON}</h6>
        <div className="multi-range">
          <FormControl
            type="range"
            step="100"
            min={100}
            max={50000}
            value={costMin}
            onChange={(e) => {
              const val = Number(e.target.value);
              const max = filters?.estimate_price_max || 50000;
              const newMin = Math.min(val, max - 100);
              setCostMin(newMin);
              debouncedUpdateFilter("estimate_price_min", newMin);
            }}
            className="dual_range range_values"
            name="estimate_price_min"
          />
          <FormControl
            type="range"
            step="100"
            min={100}
            max={50000}
            value={costMax}
            onChange={(e) => {
              const val = Number(e.target.value);
              const min = filters?.estimate_price_min || 100;
              const newMax = Math.max(val, min + 100);
              setCostMax(newMax);
              debouncedUpdateFilter("estimate_price_max", newMax);
            }}
            className="dual_range range_values"
            name="estimate_price_max"
          />
        </div>
        <div className="range-label">
          <span className="value">₹{rupeeFormat(costMin)}</span>
          <span className="float-end">
            ₹{rupeeFormat(costMax)}+
          </span>
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>{FILTER?.TOTAL_SAFARI}</h6>
        <div className="multi-range">
          <FormControl
            type="range"
            min="1"
            max="10"
            value={safariMin}
            onChange={(e) => {
              const val = Number(e.target.value);
              const max = filters?.no_of_safari_max || 10;
              if (val <= max) {
                setSafariMin(val)
                debounceSafariFilter("no_of_safari_min", val);
              }
            }}
            className="dual_range range_values"
            name="no_of_safari_min"
          />
          <FormControl
            type="range"
            min="1"
            max="10"
            value={safariMax}
            onChange={(e) => {
              const val = Number(e.target.value);
              const min = filters?.no_of_safari_min || 1;
              if (val >= min) {
                setSafariMax(val)
                debounceSafariFilter("no_of_safari_max", val);
              }
            }}
            className="dual_range range_values"
            name="no_of_safari_max"
          />
        </div>
        <div className="range-label">
          <span className="value">
            {safariMin}
          </span>
          <span className="float-end">
            {safariMax}+
          </span>
        </div>
      </div>
      <div className="title_filter mb-3">
        <h6>{FILTER?.THEME}</h6>
        <div className="input_check">
          {Array.isArray(safariAgenda) && safariAgenda.length > 0 ? (
            safariAgenda.map((theme) => (
              <div className="d-flex align-items-center pt-1" key={theme.value}>
                <input
                  type="checkbox"
                  className="type checkbox_design me-3"
                  id={`share_safari_agenda-${theme.value}`}
                  value={theme.value}
                  checked={
                    Array.isArray(filters?.share_safari_agenda_id) &&
                    filters.share_safari_agenda_id.includes(theme.value)
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const current = filters?.share_safari_agenda_id || [];
                    const newValues = checked
                      ? [...current, theme.value]
                      : current.filter((v) => v !== theme.value);
                    updateFilter("share_safari_agenda_id", newValues);
                  }}
                />
                <label htmlFor={`share_safari_agenda-${theme.value}`}>
                  {theme.label}
                </label>
              </div>
            ))
          ) : masterLoading ? (
            <AccommodationFilterSkeleton count={2} />
          ) : (
            <p>{FILTER?.NO_FILTER}</p>
          )}
        </div>
      </div>
      <div className="title_filter mb-3">
        <h6>{FILTER?.ORGANIZER}</h6>
        <div className="input_check">
          {Array.isArray(safariHostType) && safariHostType.length > 0 ? (
            safariHostType.map((org) => (
              <div className="d-flex align-items-center pt-1" key={org.value}>
                <input
                  type="checkbox"
                  className="type checkbox_design me-3"
                  id={`host-type-${org.value}`}
                  value={org.value}
                  checked={
                    Array.isArray(filters?.host_type) &&
                    filters.host_type.includes(org.value)
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const current = filters?.host_type || [];
                    const newValues = checked
                      ? [...current, org.value]
                      : current.filter((v) => v !== org.value);
                    updateFilter("host_type", newValues);
                  }}
                />
                <label htmlFor={`host-type-${org.value}`}>{org.label}</label>
              </div>
            ))
          ) : masterLoading ? (
            <AccommodationFilterSkeleton count={3} />
          ) : (
            <p>{FILTER?.NO_FILTER}</p>
          )}
        </div>
      </div>
      <div className="title_filter mb-3">
        <h6>{FILTER?.CATEGORY}</h6>
        <div className="input_check">
          {Array.isArray(safariCategory) && safariCategory.length > 0 ? (
            safariCategory.map((budget) => (
              <div
                className="d-flex align-items-center pt-1"
                key={budget.value}
              >
                <input
                  type="checkbox"
                  className="type checkbox_design me-3"
                  id={`stay-category-${budget.value}`}
                  value={budget.value}
                  checked={
                    Array.isArray(filters?.stay_category_id) &&
                    filters.stay_category_id.includes(budget.value)
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const current = filters?.stay_category_id || [];
                    const newValues = checked
                      ? [...current, budget.value]
                      : current.filter((v) => v !== budget.value);
                    updateFilter("stay_category_id", newValues);
                  }}
                />
                <label htmlFor={`stay-category-${budget.value}`}>
                  {budget.label}
                </label>
              </div>
            ))
          ) : masterLoading ? (
            <AccommodationFilterSkeleton count={4} />
          ) : (
            <p>{FILTER?.NO_FILTER}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShareSafariFilter;
